import DataSelectService from 'services/DataSelectService';

class DataSelectAdapter extends DataSelectService {
  mapList(list, valueProp = null, labelProp = null) {
    return list.map((item) => {
      return {
        value: valueProp ? item[valueProp] : item,
        label: labelProp ? item[labelProp] : item
      };
    });
  }

  loadTVs(params) {
    return this.getTVs(params.datatype).then((results) => this.mapList(results, 'MIC', 'Name'));
  }

  loadAssetClasses(params) {
    return this.getAssetClasses(params.datatype, params.tv).then((results) => this.mapList(results));
  }

  loadSubAssetClasses(params) {
    return this.getSubAssetClasses(params.datatype, params.tv, params.assetclass).then((results) =>
      this.mapList(results)
    );
  }

  loadInstruments(params) {
    return this.getInstruments(params.datatype, params.tv, params.assetclass, params.subassetclass).then((results) =>
      this.mapList(results)
    );
  }

  loadSegmentMics(params) {
    return this.getSegmentMics(
      params.datatype,
      params.tv,
      params.assetclass,
      params.subassetclass,
      params.instrument
    ).then((results) => this.mapList(results));
  }

  loadOrderTypes(params) {
    return this.getOrderTypes(
      params.datatype,
      params.tv,
      params.assetclass,
      params.subassetclass,
      params.instrument,
      params.instrumentmic,
    ).then((results) => this.mapList(results));
  }
}

const dataSelectAdapter = new DataSelectAdapter();
export default dataSelectAdapter;



// WEBPACK FOOTER //
// ./src/adapters/DataSelectsAdapter.js